// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

type Props = {
  date?: number | string,
  format?: string,
  lang?: string
};

const defaultProps = {
  date: undefined,
  format: 'DD-MMM-YYYY',
  lang: 'en'
};

function DateComponent({ date, format, lang }: Props) {
  const momentDate = moment(date);

  return <span>{momentDate.isValid() ? momentDate.locale(lang).format(format) : date}</span>;
}

DateComponent.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    lang: state.settings.language
  };
}

export default connect(
  mapStateToProps,
  null
)(DateComponent);
